// AUTOGENERATED FILE - DO NOT MODIFY!
// This file was generated by Djinni from 001_fatmap_api_constants.djinni
export var ImageryOverlay;
(function (ImageryOverlay) {
    ImageryOverlay[ImageryOverlay["NONE"] = 0] = "NONE";
    ImageryOverlay[ImageryOverlay["GRADIENT"] = 1] = "GRADIENT";
    ImageryOverlay[ImageryOverlay["AVALANCHE"] = 2] = "AVALANCHE";
    ImageryOverlay[ImageryOverlay["ASPECT"] = 3] = "ASPECT";
    ImageryOverlay[ImageryOverlay["GRID"] = 4] = "GRID";
})(ImageryOverlay || (ImageryOverlay = {}));
/** More options to be added later. */
export var HeatmapColorScheme;
(function (HeatmapColorScheme) {
    HeatmapColorScheme[HeatmapColorScheme["BLUE"] = 0] = "BLUE";
    HeatmapColorScheme[HeatmapColorScheme["BLUE_RED"] = 1] = "BLUE_RED";
    HeatmapColorScheme[HeatmapColorScheme["ORANGE"] = 2] = "ORANGE";
    HeatmapColorScheme[HeatmapColorScheme["PINK"] = 3] = "PINK";
    HeatmapColorScheme[HeatmapColorScheme["PURPLE"] = 4] = "PURPLE";
    HeatmapColorScheme[HeatmapColorScheme["SUNSET"] = 5] = "SUNSET";
    HeatmapColorScheme[HeatmapColorScheme["WEEKLY_RAINBOW"] = 6] = "WEEKLY_RAINBOW";
})(HeatmapColorScheme || (HeatmapColorScheme = {}));
export var MeasurementUnitSystem;
(function (MeasurementUnitSystem) {
    MeasurementUnitSystem[MeasurementUnitSystem["METRIC"] = 0] = "METRIC";
    MeasurementUnitSystem[MeasurementUnitSystem["IMPERIAL"] = 1] = "IMPERIAL";
})(MeasurementUnitSystem || (MeasurementUnitSystem = {}));
export var MeasurementUnit;
(function (MeasurementUnit) {
    MeasurementUnit[MeasurementUnit["METER"] = 0] = "METER";
    MeasurementUnit[MeasurementUnit["KILOMETER"] = 1] = "KILOMETER";
    MeasurementUnit[MeasurementUnit["FEET"] = 2] = "FEET";
    MeasurementUnit[MeasurementUnit["MILE"] = 3] = "MILE";
})(MeasurementUnit || (MeasurementUnit = {}));
/**
 * Describes the source of the content feature
 *
 * Could be one of the vector tiles or a custom line or marker
 */
export var ContentGroup;
(function (ContentGroup) {
    ContentGroup[ContentGroup["STRAVAPOI"] = 0] = "STRAVAPOI";
    ContentGroup[ContentGroup["SEGMENTS"] = 1] = "SEGMENTS";
    ContentGroup[ContentGroup["CURATED"] = 2] = "CURATED";
    ContentGroup[ContentGroup["OSM"] = 3] = "OSM";
    ContentGroup[ContentGroup["CUSTOMLINE"] = 4] = "CUSTOMLINE";
    ContentGroup[ContentGroup["CUSTOMMARKER"] = 5] = "CUSTOMMARKER";
    ContentGroup[ContentGroup["ROUTES"] = 6] = "ROUTES";
    ContentGroup[ContentGroup["ACTIVITIES"] = 7] = "ACTIVITIES";
    ContentGroup[ContentGroup["RECORD"] = 8] = "RECORD";
})(ContentGroup || (ContentGroup = {}));
export var FollowMode;
(function (FollowMode) {
    FollowMode[FollowMode["HEADING"] = 0] = "HEADING";
    FollowMode[FollowMode["POSITION"] = 1] = "POSITION";
})(FollowMode || (FollowMode = {}));
export var ClickSourceType;
(function (ClickSourceType) {
    ClickSourceType[ClickSourceType["MOUSE"] = 0] = "MOUSE";
    ClickSourceType[ClickSourceType["TOUCH"] = 1] = "TOUCH";
})(ClickSourceType || (ClickSourceType = {}));
export var MouseButtonCode;
(function (MouseButtonCode) {
    MouseButtonCode[MouseButtonCode["RIGHT"] = 0] = "RIGHT";
    MouseButtonCode[MouseButtonCode["MIDDLE"] = 1] = "MIDDLE";
    MouseButtonCode[MouseButtonCode["LEFT"] = 2] = "LEFT";
})(MouseButtonCode || (MouseButtonCode = {}));
export var ClickEventType;
(function (ClickEventType) {
    ClickEventType[ClickEventType["CONTENT"] = 0] = "CONTENT";
    ClickEventType[ClickEventType["MAP"] = 1] = "MAP";
    ClickEventType[ClickEventType["USERMARKER"] = 2] = "USERMARKER";
})(ClickEventType || (ClickEventType = {}));
export var TestingContextStatus;
(function (TestingContextStatus) {
    TestingContextStatus[TestingContextStatus["NOCONTEXT"] = 0] = "NOCONTEXT";
    TestingContextStatus[TestingContextStatus["ENTERING"] = 1] = "ENTERING";
    TestingContextStatus[TestingContextStatus["ENTERINGFAILED"] = 2] = "ENTERINGFAILED";
    TestingContextStatus[TestingContextStatus["ENTERED"] = 3] = "ENTERED";
    TestingContextStatus[TestingContextStatus["LEAVING"] = 4] = "LEAVING";
})(TestingContextStatus || (TestingContextStatus = {}));
export var ContourSource;
(function (ContourSource) {
    ContourSource[ContourSource["STRAVA"] = 0] = "STRAVA";
    ContourSource[ContourSource["MAPBOX"] = 1] = "MAPBOX";
})(ContourSource || (ContourSource = {}));
/** https://docs.mapbox.com/data/tilesets/reference/mapbox-streets-v8/#names */
export var Language;
(function (Language) {
    Language[Language["LOCAL"] = 0] = "LOCAL";
    Language[Language["EN"] = 1] = "EN";
    Language[Language["ES"] = 2] = "ES";
    Language[Language["FR"] = 3] = "FR";
    Language[Language["DE"] = 4] = "DE";
    Language[Language["IT"] = 5] = "IT";
    Language[Language["PT"] = 6] = "PT";
    Language[Language["RU"] = 7] = "RU";
    Language[Language["JA"] = 8] = "JA";
    Language[Language["ZH_HANS"] = 9] = "ZH_HANS";
    Language[Language["ZH_HANT"] = 10] = "ZH_HANT";
})(Language || (Language = {}));
export var MapType;
(function (MapType) {
    MapType[MapType["STRAVA_TOPO_LIGHT"] = 0] = "STRAVA_TOPO_LIGHT";
    MapType[MapType["STRAVA_STREETS_TOPO_LIGHT"] = 1] = "STRAVA_STREETS_TOPO_LIGHT";
    MapType[MapType["STRAVA_TOPO_DARK"] = 2] = "STRAVA_TOPO_DARK";
    MapType[MapType["STRAVA_TOPO_WINTER"] = 3] = "STRAVA_TOPO_WINTER";
    MapType[MapType["STRAVA_TOPO_WINTER_HYBRID"] = 4] = "STRAVA_TOPO_WINTER_HYBRID";
    MapType[MapType["STRAVA_HYBRID"] = 5] = "STRAVA_HYBRID";
    MapType[MapType["STRAVA_SATELLITE_SUMMER"] = 6] = "STRAVA_SATELLITE_SUMMER";
    MapType[MapType["STRAVA_SATELLITE_WINTER"] = 7] = "STRAVA_SATELLITE_WINTER";
})(MapType || (MapType = {}));
export var PolylineHighlightSectionType;
(function (PolylineHighlightSectionType) {
    PolylineHighlightSectionType[PolylineHighlightSectionType["GOLD"] = 0] = "GOLD";
    PolylineHighlightSectionType[PolylineHighlightSectionType["SILVER"] = 1] = "SILVER";
    PolylineHighlightSectionType[PolylineHighlightSectionType["BRONZE"] = 2] = "BRONZE";
    PolylineHighlightSectionType[PolylineHighlightSectionType["PURPLE"] = 3] = "PURPLE";
    PolylineHighlightSectionType[PolylineHighlightSectionType["TEAL"] = 4] = "TEAL";
    PolylineHighlightSectionType[PolylineHighlightSectionType["BLUE"] = 5] = "BLUE";
})(PolylineHighlightSectionType || (PolylineHighlightSectionType = {}));
export var PolylineHighlightSectionIcon;
(function (PolylineHighlightSectionIcon) {
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["GOLD_PR"] = 0] = "GOLD_PR";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["SILVER_PR"] = 1] = "SILVER_PR";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["BRONZE_PR"] = 2] = "BRONZE_PR";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["LOCAL_LEGEND"] = 3] = "LOCAL_LEGEND";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["BEST_EFFORT_POWER"] = 4] = "BEST_EFFORT_POWER";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["BEST_EFFORT_CLIMB"] = 5] = "BEST_EFFORT_CLIMB";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["BEST_EFFORT_PACE"] = 6] = "BEST_EFFORT_PACE";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["TOP10_10"] = 7] = "TOP10_10";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["TOP10_9"] = 8] = "TOP10_9";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["TOP10_8"] = 9] = "TOP10_8";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["TOP10_7"] = 10] = "TOP10_7";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["TOP10_6"] = 11] = "TOP10_6";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["TOP10_5"] = 12] = "TOP10_5";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["TOP10_4"] = 13] = "TOP10_4";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["TOP10_3"] = 14] = "TOP10_3";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["TOP10_2"] = 15] = "TOP10_2";
    PolylineHighlightSectionIcon[PolylineHighlightSectionIcon["TOP10_1"] = 16] = "TOP10_1";
})(PolylineHighlightSectionIcon || (PolylineHighlightSectionIcon = {}));
export var RouteWaypointCategory;
(function (RouteWaypointCategory) {
    RouteWaypointCategory[RouteWaypointCategory["ATTRACTION"] = 0] = "ATTRACTION";
    RouteWaypointCategory[RouteWaypointCategory["CAMP_SITE"] = 1] = "CAMP_SITE";
    RouteWaypointCategory[RouteWaypointCategory["MEETING_SPOT"] = 2] = "MEETING_SPOT";
    RouteWaypointCategory[RouteWaypointCategory["TRAILHEAD"] = 3] = "TRAILHEAD";
    RouteWaypointCategory[RouteWaypointCategory["TRANSITION_ZONE"] = 4] = "TRANSITION_ZONE";
    RouteWaypointCategory[RouteWaypointCategory["SEGMENT_END"] = 5] = "SEGMENT_END";
    RouteWaypointCategory[RouteWaypointCategory["SEGMENT_START"] = 6] = "SEGMENT_START";
    RouteWaypointCategory[RouteWaypointCategory["LODGING"] = 7] = "LODGING";
    RouteWaypointCategory[RouteWaypointCategory["REST_AREA"] = 8] = "REST_AREA";
    RouteWaypointCategory[RouteWaypointCategory["GAS_STATION"] = 9] = "GAS_STATION";
    RouteWaypointCategory[RouteWaypointCategory["AID_STATION"] = 10] = "AID_STATION";
    RouteWaypointCategory[RouteWaypointCategory["ALERT"] = 11] = "ALERT";
    RouteWaypointCategory[RouteWaypointCategory["DISTANCE_MARKER"] = 12] = "DISTANCE_MARKER";
    RouteWaypointCategory[RouteWaypointCategory["CHECKPOINT"] = 13] = "CHECKPOINT";
    RouteWaypointCategory[RouteWaypointCategory["PHARMACY"] = 14] = "PHARMACY";
    RouteWaypointCategory[RouteWaypointCategory["BIKE_SHOP"] = 15] = "BIKE_SHOP";
    RouteWaypointCategory[RouteWaypointCategory["MONUMENT"] = 16] = "MONUMENT";
    RouteWaypointCategory[RouteWaypointCategory["BAR"] = 17] = "BAR";
    RouteWaypointCategory[RouteWaypointCategory["GROCERY"] = 18] = "GROCERY";
    RouteWaypointCategory[RouteWaypointCategory["RESTAURANT"] = 19] = "RESTAURANT";
    RouteWaypointCategory[RouteWaypointCategory["PEAK"] = 20] = "PEAK";
    RouteWaypointCategory[RouteWaypointCategory["ART"] = 21] = "ART";
    RouteWaypointCategory[RouteWaypointCategory["WATER_SOURCE"] = 22] = "WATER_SOURCE";
    RouteWaypointCategory[RouteWaypointCategory["COFFEE"] = 23] = "COFFEE";
    RouteWaypointCategory[RouteWaypointCategory["PARK"] = 24] = "PARK";
    RouteWaypointCategory[RouteWaypointCategory["VIEWPOINT"] = 25] = "VIEWPOINT";
    RouteWaypointCategory[RouteWaypointCategory["PARKING"] = 26] = "PARKING";
    RouteWaypointCategory[RouteWaypointCategory["BEACH"] = 27] = "BEACH";
    RouteWaypointCategory[RouteWaypointCategory["RESTROOM"] = 28] = "RESTROOM";
    RouteWaypointCategory[RouteWaypointCategory["GENERIC"] = 29] = "GENERIC";
    RouteWaypointCategory[RouteWaypointCategory["ROUTE_PLANNED_START"] = 30] = "ROUTE_PLANNED_START";
    RouteWaypointCategory[RouteWaypointCategory["ROUTE_PLANNED_FINISH"] = 31] = "ROUTE_PLANNED_FINISH";
    RouteWaypointCategory[RouteWaypointCategory["ROUTE_PLANNED_WAYPOINT"] = 32] = "ROUTE_PLANNED_WAYPOINT";
})(RouteWaypointCategory || (RouteWaypointCategory = {}));
export var RoadSurfaceType;
(function (RoadSurfaceType) {
    RoadSurfaceType[RoadSurfaceType["PAVED"] = 0] = "PAVED";
    RoadSurfaceType[RoadSurfaceType["UNPAVED"] = 1] = "UNPAVED";
    RoadSurfaceType[RoadSurfaceType["UNSPECIFIED"] = 2] = "UNSPECIFIED";
})(RoadSurfaceType || (RoadSurfaceType = {}));
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DISABLED"] = 0] = "DISABLED";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARNING"] = 2] = "WARNING";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
})(LogLevel || (LogLevel = {}));
